import FirestorePipe from "../utils/pipe";
import { QueryConstraint, Unsubscribe, where } from "firebase/firestore";

class BillingScheduleDB extends FirestorePipe {
  public static readonly colName = 'BillingSchedule'

  constructor() {
    super(BillingScheduleDB.colName);
  }

  public getAll(...params: QueryConstraint[]): Promise<any[]> {
    return this._getAll<any>(...params);
  }

  public get(id: string): Promise<any> {
    return this._get<any>(id);
  }

  public on(listener: (data: any[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on<any>(listener, ...params);
  }

  public create(data: any): Promise<string> {
    return this._create<any>(data);
  }

  public update(id: string, data: any): Promise<void> {
    return this._update<any>(id, data);
  }

  public delete(id: string): Promise<void> {
    return this._delete(id);
  }

  /**
   * Busca o agendamento de cobrança pelo ID da loja
   * @param {string} storeId - ID da loja
   */
  public async getByStoreId(storeId: string): Promise<any | null> {
    const results = await this.getAll(where('storeId', '==', storeId));
    return results.length > 0 ? results[0] : null;
  }
}

export default BillingScheduleDB;
